/* eslint-disable camelcase */
import {
  Grid,
  Typography,
  IconButton,
} from '@mui/material';
import { Clear } from '@mui/icons-material';
import { grey } from '@mui/material/colors';
import { useDeleteCompanyManagerMutation } from '../../../../../../graphql/generated/graphql';

import { delCompanyManager } from '../../../../../hooks/companyInfo';
import Avatar from '../../../avatar';

export default function ListCompanyManagers(props: any) {
  const [deleteManager] = useDeleteCompanyManagerMutation();
  const { manager, idx } = props;
  const { id, full_name, url_avatar } = manager

  const deleteCompanyManager = async () => {
    try {
      await deleteManager({
        variables: {
          user_id: id,
        },
      });
      delCompanyManager(idx);
    } catch (e) {
      console.error(e);
    }
  }

  return (
    <Grid
      item
      sx={{
        width: '500px',
        maxWidth: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        my: 2,
      }}
    >
      <Grid
        item
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Avatar url={url_avatar} size={50} />
        <Typography
          sx={{
            ml: 1,
          }}
          component="p"
          variant="body1"
        >
          {full_name}
        </Typography>
      </Grid>
      <IconButton onClick={deleteCompanyManager}>
        <Clear
          sx={{
            color: grey[500],
            cursor: 'pointer',
          }}
          fontSize="small"
        />
      </IconButton>
    </Grid>
  );
}
